export const signUpFormContentStyle = {
	wrapper: {
		maxWidth: '372px',
		width: '100%',
	},

	header: {
		'& .MuiTypography-root': {
			marginBottom: '16px',
		},
	},

	logIn: {
		display: 'flex',
		justifyContent: 'center',
		color: 'var(--neutral-500)',
		marginBottom: '14px',
	},

	link: {
		'&:first-letter': {
			textTransform: 'uppercase',
		},
	},
};
